import axios from "axios";
import { useQuery } from "react-query";

// Single bootstrap context for the Lenses 2 dashboard: the per-template "date
// that matters" map + data-driven date period options. Extensible BE-side to
// location/segments later (each is its own top-level key on the response).
export const useGetLensesContext = ({ enabled = true } = {}) => {
  return useQuery(
    "lensV2Context",
    () => axios.get("/api/lenses/v2/context").then((r) => r.data),
    { staleTime: 5 * 60 * 1000, enabled }
  );
};
